import {AjaxRequest} from "./ajax-request";
import Inputmask from "inputmask";
import {Modal} from "./modal";
import * as translation from "./translations";
import {getItem, setItem} from "./localStorage";
import {ErrorMsg} from "./error_model";
import {createCheckboxsString} from "./helpers/createCheckboxs";


const modal = new Modal();
const ajax = new AjaxRequest();
const spinner = document.querySelector('.spinner');

const clubIdInput = document.querySelector('#clubId');
let selectedConsentIds = [];
let consentDefinitions;
const consentDefinitionsContainer = document.querySelector('.consent_definitions');
const toggleInvoicesData = document.querySelector('#checkbox_invoice');
const invoicesData = document.querySelector('#invoices_data');


const selector = document.getElementById("birthday");
const selectorPostalCode = document.getElementById("postalCode");
const selectorCompanyPostalCode = document.getElementById("companyPostalCode");
const selectorNip = document.getElementById("companyTaxIdentificationNumber");


let selectedClubId = getItem('clubId');
let membershipSelected = getItem('membership');
const selectedType = getItem('type');
// const selectedType = "multisport"


if (selectedClubId) {
    clubIdInput.value = selectedClubId;
}


const im = new Inputmask({
    alias: 'datetime', inputFormat: "yyyy-mm-dd", placeholder: 'yyyy-mm-dd', showMaskOnHover: false,
    showMaskOnFocus: false, clearMaskOnLostFocus: true,
});
const imNip = new Inputmask({
    mask: '9999999999', placeholder: '', showMaskOnHover: false,
    showMaskOnFocus: false, clearMaskOnLostFocus: true,
});

const imPostalCode = new Inputmask({
    mask: '99-999', placeholder: '', showMaskOnHover: false,
    showMaskOnFocus: false, clearMaskOnLostFocus: true,
});


im.mask(selector);
imPostalCode.mask(selectorPostalCode);
imPostalCode.mask(selectorCompanyPostalCode);
imNip.mask(selectorNip);


$(document).ready(function () {
    let action = document.querySelector('form').getAttribute('data-action');
    const errors = new ErrorMsg().errorsCode;


    if (action === 'my_ajax_create_user') {
        getConsentDefinitionsForMember(selectedClubId).then(res => {
            spinner.style.display = "none";
            createCheckboxItems(res['data']['results']);

        })
    }
    // new
    // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d@$!%*?&\-_\#\^\;\:\(\)\,\.\<\>]{8,}$/
    //
    // old
    // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/

    $.validator.addMethod("strongPassword", function (value, element) {
        return this.optional(element) || /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_@\-().;|+#^<>:'$!%*?&])[A-Za-z\d_@\-().;|+#^<>:'$!%*?&]{8,}$/.test(value);
    }, translation.translations[translation.lang].strongPassword);
    $.validator.addMethod("postalCode", function (value, element) {
        return this.optional(element) || /^\d{2}-\d{3}$/.test(value);
    }, translation.translations[translation.lang].postalCodeFormat_error);
    $.validator.addMethod("birthdayCheck", function (value, element) {
        console.log(value.length)
        let data = new Date(value);
        let today = new Date();
        let isValid = false;
        if (!isNaN(data.getTime())) {
            isValid = today.getFullYear() - data.getFullYear() < 100
        }
        return this.optional(element) || isValid;
    }, translation.translations[translation.lang].maxAge);
    $.validator.addMethod("birthdayMin", function (value, element) {
        console.log(value.length)
        let data = new Date(value);
        let today = new Date();
        let isValid = false;
        if (!isNaN(data.getTime())) {
            let age = today.getFullYear() - data.getFullYear();
            if (
                age > 18 ||
                (age === 18 && (today.getMonth() > data.getMonth() ||
                    (today.getMonth() === data.getMonth() && today.getDate() >= data.getDate())))
            ) {
                isValid = true;
            }
        }
        return this.optional(element) || isValid;
    }, translation.translations[translation.lang].minAge);


    $('#data_form').validate({
        onclick: false,
        rules: {
            clubId: {
                required: true
            },
            cellPhone: {
                required: true,
                minlength: 9,
                maxlength: 9
            },

            email: {
                required: true
            },
            repeat_email: {
                equalTo: '#email',
                required: true,
            },
            password: {
                strongPassword: true,
            },
            birthday: {
                birthdayCheck: true,
                birthdayMin: true,
                required: true
            },
            repeat_password: {
                required: true,
                equalTo: "#password"
            },

            postalCode: {
                postalCode: true
            },

        },
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.addClass('error-message');
            if ($(element).attr('name') === 'flatNumber' || $(element).attr('name') === 'companyPostalCode' || $(element).attr('name') === 'birthday') {
                error.addClass('offset-right');
            }
            // if ($(element).attr('name') === 'password' || $(element).attr('name') === 'pa' || $(element).attr('name') === 'pa2') {
            //     error.addClass('offset-bottom');
            // }


            error.insertAfter(element);
        },
        messages: {
            city: {},
            cellPhone: {
                required: translation.translations[translation.lang].required,
                minlength: translation.translations[translation.lang].minLength,
                maxlength: translation.translations[translation.lang].maxLength,
            },
            postalCode: {},
            email: {
                email: translation.translations[translation.lang].emailError,
                required: translation.translations[translation.lang].required,

            },

            repeat_email: {
                required: translation.translations[translation.lang].required,
                equalTo: translation.translations[translation.lang].equalTo
            },
            password: {
                required: translation.translations[translation.lang].required,
                pattern: translation.translations[translation.lang].strongPassword,

            },

            flat: {
                required: translation.translations[translation.lang].required,
            },
            street: {
                required: translation.translations[translation.lang].required,
            },
            sex: {
                required: translation.translations[translation.lang].required,
            },
            birthday: {
                required: translation.translations[translation.lang].required,
            },
            flatNumber: {
                required: translation.translations[translation.lang].required,
            },

            repeat_password: {
                required: translation.translations[translation.lang].required,
                equalTo: translation.translations[translation.lang].equalTo
            },
        },
        submitHandler: async function (form, event) {
            debugger
            event.preventDefault();
            spinner.style.display = "flex";
            let data = {}
            $(form).serializeArray().forEach(obj => {
                data[obj.name] = obj.value
            })
            data['selectedConsentIds'] = selectedConsentIds
            if (selectedType === "multisport" || selectedType === "medicover") {
                data['outerSystemType'] = 1;
            }
            if (toggleInvoicesData.checked) {
                data['invoice'] = toggleInvoicesData.checked;
            }
            data['membershipDefinitionId'] = membershipSelected;


            if (action === "my_ajax_create_user") {
                setItem('user', data);
                let res = await createUser(data)
                if (res['data']) {
                    debugger
                    handleResponse(res['data'])
                }
            } else {
                let res = await updateMember(data)
                if (res['data']) {
                    handleResponse(res['data'])
                }
            }


            // ajax.request('my_ajax_action_order', data)

            // $.ajax({
            //     url: ajaxurl,
            //     type: 'POST',
            //     dataType: 'json',
            //     data: $(form).serialize(),
            //     success: function (response) {
            //     },
            //     error: function () {
            //     }
            // });
        }
    });


    toggleInvoicesData.addEventListener('change', () => {
        invoicesData.classList.toggle('d-none')
        if (!invoicesData.classList.contains('d-none')) {
            toggleInvoicesValidation('add');
        } else {
            toggleInvoicesValidation('remove');
        }
    });


    function toggleInvoicesValidation(type) {
        if (type === 'add') {
            $('#companyTaxIdentificationNumber').rules(type, {
                required: true,
                messages: {
                    required: translation.translations[translation.lang].required,
                }
            });
            $('#companyName').rules(type, {
                required: true,
                messages: {
                    required: translation.translations[translation.lang].required,
                }
            });
            $('#companyCity').rules(type, {
                required: true,
                messages: {
                    required: translation.translations[translation.lang].required,
                }
            });
            $('#companyStreet').rules(type, {
                required: true,
                messages: {
                    required: translation.translations[translation.lang].required,
                }
            });

            $('#companyPostalCode').rules(type, {
                required: true,
                postalCode: true,
                messages: {
                    postalCode: translation.translations[translation.lang].postalCodeFormat_error,
                    required: translation.translations[translation.lang].required,
                }
            });
        } else {
            $('#companyTaxIdentificationNumber').rules(type, 'required ');
            $('#companyName').rules(type, 'required');
            $('#companyCity').rules(type, 'required');
            $('#companyStreet').rules(type, 'required');
            $('#companyPostalCode').rules(type, 'required ');
        }
    }

    async function createUser(data) {
        spinner.style.display = "flex"
        try {
            let response = await ajax.request('my_ajax_create_user', data);
            spinner.style.display = "none";
            return response;

        } catch (error) {
            console.log(error)
        }
    }

    async function updateMember(data) {

        spinner.style.display = "flex"
        try {

            let response = await ajax.request('my_ajax_update_member', data);
            spinner.style.display = "none"
            return response
        } catch (error) {
            console.log("error" + error)
        }
    }


    const handleResponse = (res) => {
        debugger
        if (res['errors']) {
            let error = res['errors'][0];
            let code = error['responseCode'];
            if (errors[translation.lang][code.trim()]) {
                if (code === '4.6') {
                    modal.show(`${translation.translations[translation.lang].provided} ${error['message'].includes('phone') ? `${translation.translations[translation.lang].phone}` : 'email'} ${errors[translation.lang][code.trim()]}`);
                } else if (code === '4.34') {
                    modal.show(errors[translation.lang][code.trim()][selectedType]);
                } else {
                    modal.show(errors[translation.lang][code.trim()])
                }
            } else {
                modal.show(translation.translations[translation.lang].sendError)
            }
        } else if (res['authorizationData']['name']) {

            if (!order) {
                window.location.href = '/profil' + (translation.lang !== 'pl' ? '_' + translation.lang : '');
            } else {
                window.location.href = '/order' + (translation.lang !== 'pl' ? '_' + translation.lang : '');
            }
        }
    }

    async function getConsentDefinitionsForMember(clubId) {
        spinner.style.display = "flex"
        let data = {
            clubId: clubId
        }
        try {
            let response = await ajax.request('my_ajax_get_consent_definitions_for_member', data);
            spinner.style.display = "none"
            return response;

        } catch (error) {
            console.log(error)
        }
    }

    function addConsentsValidation(data) {
        data.forEach(item => {
            if (item.required) {
                $(`#${item.consentDefinitionId}`).rules('add', {
                    required: true,
                    messages: {
                        required: translation.translations[translation.lang].required // Wiadomość wyświetlana w razie błędu
                    }
                });
            }
        })
    }

    const createCheckboxItems = (data) => {
        data = data.filter(consent => consent.required);
        consentDefinitionsContainer.innerHTML = createCheckboxsString(data);

        addConsentsValidation(data);

        consentDefinitions = data;
        const checkboxes = document.querySelectorAll('.checkbox-group input');
        checkboxes.forEach(item => {
            if (item.checked) {
                selectedConsentIds.push(item.getAttribute('data-id'));
            }
            item.addEventListener('click', () => {
                if (item.checked) {
                    selectedConsentIds.push(item.getAttribute('data-id'));
                } else {
                    selectedConsentIds = selectedConsentIds.filter(val => val !== item.getAttribute('data-id'));
                }
            })
        })

    }
    if (selectedType === "multisport") {
        $('#cardNumber').rules('add', {
            rangelength: [12, 12],
            messages: {
                rangelength: translation.translations[translation.lang].cardNumber,
            }
        });

        $('#multisport').css('display', 'grid');
    } else {
        $('#multisport').css('display', 'none');
    }
});

const params = new URLSearchParams(window.location.search);
const order = params.get('order_id');










